import { connect } from "react-redux";
import Feedback from "./Feedback";
import { sendFeedback } from "../../actions/FeedbackActions";
import type { AppDispatch, RootState } from "../../store";

const mapStateToProps = (state: RootState) => {
  const { uid } = state.userDetails;
  return {
    uid
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    onSubmit: ({
      uid,
      sentimentScore,
      title,
      body
    }: {
      uid: string;
      sentimentScore: number | null;
      title: string;
      body: string;
    }) => {
      dispatch(
        sendFeedback({ uid, sentimentScore: sentimentScore ?? 0, title, body })
      );
    }
  };
};

const FeedbackContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Feedback);

export default FeedbackContainer;
